import { SelectFieldOption_Values } from "../../../../../Definitions";

export function valueIsSelectFieldOptionsValue(value: string | number | boolean | SelectFieldOption_Values | undefined, accessor: string): value is SelectFieldOption_Values {
  return (accessor === "system_id" || accessor === "system_assignment" || accessor === "lan_controller_id") && value !== undefined;
}